export default __webpack_public_path__ + "static/media/FurnitureItem11.42cb2ff4.png";